<template>
  <div v-if="asyncDataStatus_ready">
    <v-row justify="space-between">
      <v-col cols="6" md="3">
        <!-- <v-btn hidden color="#0F998E" class="white--text" @click="saveOrder">
          Shrani vrstni red
          <v-icon right dark>mdi-check</v-icon>
        </v-btn> -->
        <v-text-field
          v-if="this.comments.length"
          placeholder="Išči..."
          append-icon="mdi-search"
          v-model="filter"
          @keydown.esc="filter=''"
        ></v-text-field>
      </v-col>
      <v-col cols="auto">
        <v-btn
          color="#0F998E"
          class="white--text"
          @click="$router.push({ name: 'MyCompanyCommentsNew' })"
        >
          Nova opomba
          <v-icon right dark>mdi-plus</v-icon>
        </v-btn>
      </v-col>
    </v-row>
      <v-col  v-if="this.comments.length">
        <v-simple-table fixed-header>
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left">
                  Opombe
                </th>

                <th></th>
              </tr>
            </thead>
          </template>
        </v-simple-table>
      </v-col>
    <v-row
      v-if="this.comments.length"
      v-dragula="localComments"
      drake="comments"
    >

      <v-col
        v-for="item in filteredComments"
        :key="item.id"
        :data-id="item.id"
        cols="12"
        class="pt-0 pb-0 "
      >
        <TitleOnlyCard
          :style="{ 'border-left': `5px solid ${item.color}` }"
          :title="item.comment"
          :comment="item"
          :draggable="false"
          @delete="
            showDeleteCommentModal = true;
            deleteComment = item;
          "
          @edit="
            $router.push({
              name: 'MyCompanyCommentsEdit',
              params: { id: item.id }
            })
          "
        />
      </v-col>
    </v-row>
    <v-row v-else>
      <v-col cols="12">
        <p class="text-center">
          Ni rezultatov iskanja. Za dodajanje nove opombe uporabite gumb desno
          zgoraj.
        </p>
      </v-col>
    </v-row>

    <ConfirmDialog
      title="Brisanje opombe"
      text="Ali ste prepričani, da želite izbrisati opombo? Podatki bodo trajno izbrisani."
      okBtnText="Briši"
      v-model="showDeleteCommentModal"
      @confirmed="remove(deleteComment)"
    />
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { siIncludes } from '@/utils/str'
import asyncDataStatus from '@/mixins/asyncDataStatus'
import ConfirmDialog from '@/components/ConfirmDialog'
import TitleOnlyCard from '@/components/TitleOnlyCard'
import { objectToArray } from '@/utils/object'

export default {
  components: {
    ConfirmDialog,
    TitleOnlyCard
  },
  mixins: [asyncDataStatus],
  data () {
    return {
      filter: '',
      showDeleteCommentModal: false,
      deleteComment: null,
      localComments: []
    }
  },
  computed: {
    comments () {
      return objectToArray(this.$store.state.businessUnits.comments)
    },
    filteredComments () {
      return this.localComments.filter(comment => [comment.name, comment.comment].some(this.matchFilter))
    }
  },
  methods: {
    ...mapActions('businessUnits', ['loadComments']),
    ...mapActions('businessUnits', { removeComment: 'deleteComment' }),
    matchFilter (testString) {
      return siIncludes({ haystack: testString, needle: this.filter })
    },
    remove (item) {
      console.log(item.id)
      this.removeComment(item.id)
        .then(() => {
          /* this.$notify({
            type: 'success',
            text: 'Opomba uspešno odstranjena!'
          }) */
        })
        .catch((err) => {
          this.$notify({
            type: 'error',
            text: `Neuspešno: ${err}`
          })
        })
    }
  },
  created () {
    if (!this.$store.state.businessUnits.currentBusinessUnit) {
      this.$notify({
        type: 'error',
        text: 'Potrebna je vsaj ena aktivna poslovna enota'
      })
    } else {
      this.loadComments()
        .then(comments => {
          // console.log('com: ', comments, this.comments)
          this.localComments = this.comments
          this.asyncDataStatus_fetched()
        })
        .catch((err) => console.log(err.message))
    }
  },
  watch: {
    comments (newComment) {
      this.localComments = newComment
    }
  }
}
</script>
